// extracted by mini-css-extract-plugin
module.exports = {"backgroundImage":"BackgroundImage_backgroundImage__5xNLR"};